module.exports = __webpack_public_path__ + "static/assets/bf1bcb0f81a500192fedacbc0fad598a.jpg";